<app-page padding="0">
  <div class="h-full p-0">
    <div *ngIf="!selectedFile() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div class="gap-1">
          <div class="text-sm font-semibold uppercase text-700">Carica un file utilizzando l'apposito pulsante</div>
<!--           <div class="text-sm">Nessun file selezionato</div>
          <div class="text-sm text-700 font-light">Carica un file utilizzando l'apposito pulsante</div> -->
        </div>
        <div
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event)">
          <span>
            <app-button *ngIf="!selectedFile()" icon="upload" label="Carica il file" (click)="fileInput.click()" outlined vertical></app-button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </span>
          <div *ngIf="dragging" class="drag-overlay"></div>
        </div>
      </div>
    </div>
    <div *ngIf="selectedFile() && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div class="gap-1">
          <div class="text-md font-semibold text-700">{{selectedFile().name}}</div>
          <div class="text-md"><span class="text-700 font-light">Ultima Modifica: </span>{{ selectedFile().lastModified | date:'dd/MM/yyyy' }}</div>
          <div class="text-md"><span class="text-700 font-light">Dimensione: </span>{{ selectedFile().size | appFilesize }}</div>
         <!-- <div class="text-md"><span class="text-700 font-light">Tipo: </span>{{ selectedFile().type }}</div>-->
        </div>
        <div >
          <span>
            <app-button (click)="resetForm()" [disabled]="!canSend()" icon="close" label="Cancella il file" vertical outlined></app-button>
          </span>
        </div>
      </div>
    </div>
    <div  *ngIf="isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div *ngIf="isCheckingElaborazione()" class="flex"><span>Il file è stato trasmesso ai server di AnTeA. <br> Attendi il completamento del salvataggio sul database</span><mat-spinner style="transform: scale(0.3);bottom:35px"></mat-spinner></div>
      </div>
    </div>
  </div>
  <div footer class="text-center">
    <div>
      <div class="p-2 flex flex-end w-full" style="justify-content: end;">
        <app-button (click)="onSendClick()" [disabled]="!canSend()"  [fullWidth]="false"  icon="send" label="Trasmetti" raised/>
      </div>
    </div>
  </div>
</app-page>
